import { useCallback } from 'react';

import {
  type BillScoutSetupEntrySource,
  trackBillScoutSetupStart,
  useBillScoutSetupState,
} from 'app-components/hooks/billScoutSetup';

import { dispatchBillSetupFlowDialog } from './dispatcher';
import { dispatchRecurringSetupDialog } from 'components/GettingStartedAcme/Recurring/RecurringSetupDialog/dispatcher';

/**
 * Single entry API for the approved setup surfaces: the Bills & Income
 * dashboard card, Overview tab, and All Series tab. Control opens the legacy
 * dialog and Variant A opens the new drawer; both report the same start event
 * and source vocabulary first. Any other arm keeps the untracked pre-feature
 * dialog so a stale surface still opens something — the one place this differs
 * from mobile's `useLaunchBillScoutSetup`, which has no fallback and no-ops.
 */
export const useLaunchBillScoutSetup = (source: BillScoutSetupEntrySource): (() => void) => {
  const { isNewSetupEnabled, isControlArm } = useBillScoutSetupState();

  return useCallback(() => {
    if (isControlArm) {
      trackBillScoutSetupStart(source);
      dispatchRecurringSetupDialog({ trackSetup: true });
    } else if (isNewSetupEnabled) {
      trackBillScoutSetupStart(source);
      dispatchBillSetupFlowDialog();
    } else {
      dispatchRecurringSetupDialog();
    }
  }, [isControlArm, isNewSetupEnabled, source]);
};
